<template>
  <div>
    <div v-for="item in vehicleOrders" :key="item.id">
      <van-cell style="margin-top: 5px;">
        <van-row>
          <van-col span="5">
            {{ $t('J009','用车时间') }}
          </van-col>
          <van-col span="19" class="gray" style="font-size: 12px;">
            <div>
              <span>{{ item.startTime }}</span>
              <span class="pick" v-if="item.orderType==4">接机</span>
              <span class="pick" v-else>送机</span>
            </div>
            <!-- <div>注：出发时间仅为参考，具体送机出发时间由接车司机联系通知。</div> -->
          </van-col>
        </van-row>

        <!-- 上车 -->
        <van-row type="flex" align="center">
          <van-col span="5">
            <div>{{ $t('J023','上车地点') }}</div>
          </van-col>
          <van-col span="2">
            <div>
              <img
                src="~Assets/images/car/start.png"
                alt="上车地点"
                width="20"
                class="vertical-middle"
              >
            </div>
          </van-col>
          <van-col span="17">
            <div>{{ item.scddPoi }}</div>
            <div class="font12 gray">
              <!-- {{ orderDetail.scdd?(orderDetail.scdd.split('|')[1]):'' }} -->
              {{ item.scdd }}
            </div>
            <!-- <div
                class="font12 gray">
                {{ 22222 }}航班预计 {{ 3333 }}到达
              </div> -->
          </van-col>
        </van-row>
        <!-- 下车 -->
        <van-row type="flex" align="center">
          <van-col span="5">
            <div>{{ $t('J024','下车地点') }}</div>
          </van-col>
          <van-col span="2">
            <div>
              <img
                src="~Assets/images/car/end.png"
                alt="下车地点"
                width="21"
                class="vertical-middle"
              >
            </div>
          </van-col>
          <van-col span="17">
            <div> {{ item.xcddPoi }}</div>
            <div class="font12 gray">
              <!-- {{ orderDetail.xcdd?(orderDetail.xcdd.split('|')[1]):'' }} -->
              {{ item.xcdd }}
            </div>
          </van-col>
        </van-row>
        <van-row class="m-b-5">
          <van-col span="5">
            {{ $t('Car','用车人') }}
          </van-col>
          <van-col
            span="19"
            class="gray"
          >
            {{ item.empName }}{{ item.phoneNumber }}
          </van-col>
        </van-row>
      </van-cell>
    </div>
  </div>
</template>
<script>
// import { defineComponent } from '@vue/composition-api'
import {Checkbox, Icon, Tag, Cell, Popup,CellGroup,Field} from 'vant'
export default {
  name: 'tkcarorder',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
  },
  data(){
    return{
      vehicleOrdersnew:[]
    }
  },
  props: {
    vehicleOrders: ''
  },
  computed:{

  },
  watch:{
    vehicleOrders:{
      handler(val){
        console.log("val",val)
        this.vehicleOrdersnew=[]
        //出租人信息
        let pickinformation=[] //接机人信息
        let sendinformation=[ ] //送机人信息
        let pickcardata=[] //接机人用车信息
        let sendcardata=[] //送机人用车信息
        val.forEach((item,index)=>{
          if(item.useType==4){//接机
            pickinformation.push({
              ['phoneNumber' + (index + 1)]:item.empName,
              ['phoneNumber' + (index + 1)]:item.phoneNumber,
              ['phoneNumber' + (index + 1)]:item.useType
            })
            if(pickcardata.length==0){
              pickcardata.push(item)
            }
          }
          if(item.useType==5){//送机
            sendinformation.push({
              ['phoneNumber' + (index + 1)]:item.empName,
              ['phoneNumber' + (index + 1)]:item.phoneNumber,
              ['phoneNumber' + (index + 1)]:item.useType
            })
            if(sendcardata.length==0){
              pickcardata.push(item)
            }
          }
        })
        this.vehicleOrdersnew.push[pickcardata[0],sendcardata[0]]
      },
      immediate: true,
      deep: true

    }
  }
}
</script>
<style scoped>
 .planeBox {
    padding-bottom: 5px;
  }
  .pick{
    color: #000;
    display: inline-block;
    margin-left: 10px;
  }
</style>
